import React from 'react'
import Row from '../../../bootstrap/component/Row';
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import Input from '../../../form/component/Input'
import ContentBox from "../../../layout/component/ContentBox";
import Checkbox from "../../../form/component/Checkbox";
import { TITLE_LIST, MANDATORY_FIELDS } from './const';
import PropTypes from 'prop-types';
import MessageBox from "./MessageBox";
import { Redirect } from "react-router-dom";

const InputLine = (props) => {
    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label}>
                </LabelInput>
            </Column>
            <Column size={4}>
                <Input
                    object={props.partner}
                    onChange={props.onChange}
                    name={props.name}
                />
            </Column>
        </Row>
    )
}

const SelectLine = (props) => {
    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label}>
                </LabelInput>
            </Column>
            <Column size={4}>
                <Select
                    name={props.name}
                    object={props.partner}
                    valueList={props.valueList}
                    onChange={props.onChange}
                    addEmpty={props.addEmpty}
                />
            </Column>
        </Row>
    )
}

const CheckboxLine = (props) => {
    return (
        <Row top='M' bottom='M'>
            <Column size={2}>
                <LabelInput label={props.label}>
                </LabelInput>
            </Column>
            <Column size={4}>
                <Checkbox
                    object={props.partner}
                    name={props.name}
                    onChange={props.onChange}
                > Yes
                </Checkbox>
            </Column>
        </Row>

    )
}

const getStoreValueList = (storeList) => {
    const storeValueList = storeList.map(store => ({
        id: store.technicalName,
        value: store.displayName,
    }))

    storeValueList.sort((aStore, bStore) => {
        if (aStore.value < bStore.value) {
            return -1
        }

        if (aStore.value > bStore.value) {
            return 1
        }
        return 0
    })
    return storeValueList
}

const PartnerForm = ({title, partner, savePartner, editPartner, validationMessageList, pushValidationList, storeList, redirect}) => {

    if (!partner) {
        return null
    }

    const storeValueList = getStoreValueList(storeList)

    const onChange = (name, value) => {
        editPartner(name, value)
    }

    const onSave = () => {
        const messageList = validate()
        if ( messageList.length === 0) {
            savePartner()
        }
    }

    const validate = () => {
        const messageList = [];

        (MANDATORY_FIELDS).forEach( el => {
            if(!partner.hasOwnProperty(el.id) || !partner[el.id]){
                messageList.push({
                    messageId: el.id,
                    message: `Field ${el.value} is mandatory, please fill before saving`,
                })
            }
        })
        pushValidationList(messageList)
        return messageList
    }

    if (redirect) {
        return <Redirect to='/partner/search/' />;
    }

    return (
        <ContentBox title={title}>

            <SelectLine
                label='Title'
                name='title'
                partner={partner}
                valueList={TITLE_LIST}
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <InputLine
                label='FirstName'
                partner={partner}
                name='firstName'
                onChange={onChange}
                validation={validationMessageList}
            />

            <InputLine
                label='LastName'
                partner={partner}
                name='lastName'
                onChange={onChange}
                validation={validationMessageList}
            />

            <SelectLine
                label='Associated Clinic'
                partner={partner}
                name="store"
                valueList={storeValueList}
                onChange={onChange}
                validation={validationMessageList}
                addEmpty={true}
            />

            <CheckboxLine
                label='Treating Physician'
                partner={partner}
                name='isTreatingPhysician'
                onChange={onChange}
                validation={validationMessageList}
            />

            <CheckboxLine
                label='Active'
                partner={partner}
                name='active'
                onChange={onChange}
                validation={validationMessageList}
            />

            <button
                className="btn btn-primary"
                onClick={onSave}>
                Save
            </button>

            <Row>
                <Column size={12}>
                    <MessageBox
                        messageList={validationMessageList}
                    />
                </Column>
            </Row>

        </ContentBox>
    )
}

PartnerForm.propTypes = {
    title: PropTypes.string.isRequired,
    partner: PropTypes.object.isRequired,
    savePartner: PropTypes.func.isRequired,
    editPartner: PropTypes.func.isRequired,
    pushValidationList: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array
}

export default PartnerForm



// WEBPACK FOOTER //
// ./src/modules/partner/component/form/PartnerForm.js